export const APP_VERSION_CODE = 10106;
export const APP_VERSION_NAME = "1.1.6";
